import { forwardRef, Inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromRoot from '..';
import { DefinitionsService } from 'app/core/store/definitions/definitions.service';
import { getFirst$$ } from 'app/core/util/util';

/**
 * Guard to async load the definitions before following a route
 */
@Injectable({ providedIn: 'root' })
export class GetDefinitionsGuard implements CanActivate {
  private store: Store<fromRoot.RootState>;
  private definitionsService: DefinitionsService;


  constructor(@Inject(forwardRef(() => Store)) store, @Inject(forwardRef(() => DefinitionsService)) definitionsService) {
    this.store = store;
    this.definitionsService = definitionsService;
  }

  async canActivate(): Promise<true> {
    const state = await getFirst$$(this.store);
    await this.definitionsService.loadOnce(state.session.userContext.language);
    return true;
  }
}
